import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import GuestRegistrationPage from './pages/GuestRegistrationPage';
import ThankyouPage from './pages/ThankyouPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Footer from './components/Footer';
import Analytics from './Analytics';

import { LoadingProvider } from './components/LoadingContext';

function App() {
  return (
    <LoadingProvider>
      <Router>
        <Analytics />
        <Routes>
          <Route path="/guest-registration/:id" element={<GuestRegistrationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/thank-you" element={<ThankyouPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </Router>
    </LoadingProvider>
  );
}

export default App;